import { GCashButton } from '@src/components/Button';
import { OrderDetailsPage } from '@src/pages/EntityDetailsPage';
import {
  isOrderComplete,
  resetSwapForm,
  useWLOrderFormDispatch,
  useWLOrderFormSelector,
  useWLOrdersProvider,
} from '@talos/kyoko';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function SwapConfirmationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const rootRoute = location.pathname.split('/')[1];
  const dispatch = useWLOrderFormDispatch();
  const handleBack = () => {
    const goBackRoute = rootRoute ? `/${rootRoute}` : '/';
    navigate(goBackRoute, { replace: true });
    // Reset the form state after navigating back
    setTimeout(() => {
      dispatch(resetSwapForm({}));
    }, 200);
  };

  const sentLimitOrder = useWLOrderFormSelector(state => state.swap.meta.order);
  const { recentOrdersByOrdID } = useWLOrdersProvider();

  const order = useMemo(() => {
    if (!sentLimitOrder) {
      return null;
    }
    const recentOrder = recentOrdersByOrdID.get(sentLimitOrder.OrderID);
    if (recentOrder && recentOrder.TransactTime && sentLimitOrder.TransactTime) {
      // Compare timestamps, return the fresher one
      if (new Date(recentOrder.TransactTime).getTime() > new Date(sentLimitOrder.TransactTime).getTime()) {
        return recentOrder;
      }
    }
    return sentLimitOrder;
  }, [recentOrdersByOrdID, sentLimitOrder]);
  const orderTerminal = order && isOrderComplete(order.OrdStatus);
  if (!orderTerminal) {
    return null;
  }

  if (!order) {
    // TODO(robertz): improve by adding loading that shows after 1 second, then show a 404 after 5 seconds?
    return (
      <div className="flex h-full flex-1 flex-col items-center gap-8 p-4 text-center text-sm">something went wrong</div>
    );
  }

  return (
    <div
      data-testid="swap-confirmation-page"
      className="flex h-full flex-1 flex-col items-center gap-8 p-4 text-center text-sm"
    >
      <OrderDetailsPage order={order} />

      {/* Back button */}
      <div className="mt-auto w-full">
        <GCashButton
          onClick={handleBack}
          size="lg"
          className="w-full"
          variant="primary"
          data-testid="back-to-dashboard"
        >
          Back to Dashboard
        </GCashButton>
      </div>
    </div>
  );
}
